var _defs, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgUnique(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 58.799,
    height: 55.468,
    viewBox: "0 0 58.799 55.468",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient",
    x1: 1,
    y1: 0.5,
    x2: 0,
    y2: 0.5,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#f08089"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.251,
    stopColor: "#efab4d"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.478,
    stopColor: "#e1d159"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.68,
    stopColor: "#4694ae"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.852,
    stopColor: "#576298"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#76578f"
  })))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Intersection_32",
    "data-name": "Intersection 32",
    d: "M28.774,55.265.206,27l0,0a.713.713,0,0,1-.119-.157c-.008-.015-.011-.032-.018-.046s-.015-.04-.022-.061a.7.7,0,0,1-.04-.2c0-.013,0-.027,0-.04a.679.679,0,0,1,.044-.232c.007-.019.016-.036.025-.054a.686.686,0,0,1,.04-.085L9.094,12.044a.711.711,0,0,1,.052-.062c.012-.014.021-.028.035-.042a.675.675,0,0,1,.194-.144c.005,0,.008-.006.012-.009s.018,0,.027-.007a.7.7,0,0,1,.213-.052c.014,0,.028-.006.043-.006l.015,0H49.114a.7.7,0,0,1,.592.324l8.986,14.077a.6.6,0,0,1,.042.088c.008.018.018.034.024.052a.68.68,0,0,1,.042.232V26.5c0,.011,0,.021,0,.032a.677.677,0,0,1-.04.2c-.007.02-.013.039-.022.059s-.009.03-.017.044a.724.724,0,0,1-.121.158l0,.006L29.758,55.267a.7.7,0,0,1-.984,0ZM30.4,52.676,56.383,27.2H42.408Zm-2.742-.49L15.89,27.226a.692.692,0,0,1-.143-.027H2.405Zm1.486-.137L40.857,27.2H17.428ZM43.069,25.8H56.821l-7.91-12.39ZM29.1,13.341,17.613,25.8H40.678L29.9,13.534a.685.685,0,0,1-.16-.412h-.511A.683.683,0,0,1,29.1,13.341ZM1.978,25.8H15.216L9.593,13.869Zm39.9-.761,5.616-11.914H31.411Zm-25.47,0L27.393,13.123h-16.6ZM4.416,11.6V9.86a.7.7,0,0,1,1.4,0V11.6a.7.7,0,0,1-1.4,0ZM2.029,9.214a.7.7,0,0,1,0-1.4H3.882a.7.7,0,0,1,0,1.4Zm4.2-.074a.7.7,0,1,1,0-1.4H8.08a.7.7,0,1,1,0,1.4ZM4.29,7.09V5.349a.7.7,0,0,1,1.4,0V7.09a.7.7,0,0,1-1.4,0Zm9.821-.138V5.212a.7.7,0,1,1,1.4,0v1.74a.7.7,0,1,1-1.4,0ZM11.724,4.565a.7.7,0,1,1,0-1.4h1.852a.7.7,0,1,1,0,1.4Zm4.2-.074a.7.7,0,0,1,0-1.4h1.852a.7.7,0,1,1,0,1.4ZM13.984,2.442V.7a.7.7,0,1,1,1.4,0V2.442a.7.7,0,1,1-1.4,0Z",
    fill: "url(#linear-gradient)"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUnique);
export default __webpack_public_path__ + "static/media/unique.7ebdebdd941affdb7b18e6ad69190cd1.svg";
export { ForwardRef as ReactComponent };